import React from "react";
import "./style.scss";
import {UserDetails} from "./UserNameDisplay.types";
import userAvatar from 'assets/images/user-avatar.jpg';

export const UserNameDisplay :React.FC<UserDetails> = ({lastname,firstname}:UserDetails) => {
    return (
        <div className="user">
            <h3 className="user-name">{firstname} {lastname}</h3>
            <img src={userAvatar} className={"user-avatar"}/>
        </div>
    );
}; 